import { Modal } from 'lego-on-react';
import * as React from 'react';

import { Captcha } from '../Captcha/Captcha';

export interface CaptchaPopupProps {
    captchaUrl: string;
    onSubmit: (value: string) => void;
    visible: boolean;
}

export class CaptchaPopup extends React.Component<CaptchaPopupProps> {
    render() {
        const { captchaUrl, onSubmit, visible } = this.props;

        return (
            <Modal view="classic" theme="normal" visible={visible}>
                <Captcha captchaUrl={captchaUrl} onSubmit={onSubmit} />
            </Modal>
        );
    }
}
